import * as yup from "yup";
import { maxLength } from "./messages";

export const ProfileSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email("Please enter a valid email address (e.g., name@example.com)")
		.max(255, "Email address is too long"),
	name: yup.string().max(100, "Name must be no more than 100 characters"),
	city: yup.string().max(100, "City name must be no more than 100 characters"),
	state: yup.string().max(100, "State name must be no more than 100 characters"),
	company_name: yup.string().max(100, "Company name must be no more than 100 characters"),
	company_objective: yup
		.string()
		.max(60, maxLength("Company objective", 60))
		.nullable(),
	company_goal: yup
		.string()
		.max(60, maxLength("Company goal", 60))
		.nullable()
});
